import * as React from 'react';
import { Modal } from '@ixicare/ui';
import { Check } from 'lucide-react';
import { LANGUAGES } from '@ixicare/resources';
import { t } from '~/i18n';
import styles from './LanguageModal.module.css';

interface LanguageModalProps {
  activeCode: string;
  onSelect: (code: string) => void;
  onClose: () => void;
}

const LanguageModal: React.FC<LanguageModalProps> = ({ activeCode, onSelect, onClose }) => {
  const sorted = React.useMemo(() => [...LANGUAGES].sort((a, b) => a.nativeName.localeCompare(b.nativeName)), []);

  return (
    <Modal onClose={onClose} style={{ maxWidth: 720 }}>
      <h3 className="mb-20">{t('global.language')}</h3>
      <div className={styles.Grid}>
        {sorted.map((l) => {
          const isActive = l.code === activeCode;
          return (
            <button
              key={l.code}
              type="button"
              className={`${styles.Item} ${isActive ? styles.Active : ''}`}
              onClick={() => {
                onSelect(l.code);
                onClose();
              }}
            >
              <span className={styles.Name}>{l.nativeName}</span>
              {isActive && <Check size={16} className={styles.Check} />}
            </button>
          );
        })}
      </div>
    </Modal>
  );
};

export default LanguageModal;
